import React from 'react';
import { Box, Typography, Button, Container, Avatar } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const NoAccess: React.FC = () => {
  const handleGoBack = () => {
    window.location.href = '/'; 
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 8 }}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Avatar sx={{ bgcolor: 'error.main', width: 64, height: 64, mb: 3 }}>
          <LockIcon fontSize="large" />
        </Avatar>
        <Typography variant="h4" gutterBottom color="error">
          Acceso denegado
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
          Lo sentimos, no tienes permisos para acceder a esta sección.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoBack}
          sx={{ mt: 2 }}
        >
          Volver a la página principal
        </Button>
      </Box>
    </Container>
  );
};

export default NoAccess;
